'use strict';

/**
 * Component for the object history
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-history.hbs');

var HistoryComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'typeValue': '.history-type input[type="radio"]',
        'autosizeTextarea': 'textarea[data-autosize="true"]',
        'selectPurchasingCurrency': '#history-currency-0',
        'selectDateYear': '.date-year',
        'selectDateMonth': '.date-month',
        'selectDateDay': '.date-day',
    },

    events: {
        'change @ui.typeValue': 'checkTypeValue',
        'input @ui.autosizeTextarea': 'fixTextareaSize',
    },

    previousCollectionsField: null,

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        previousCollectionsField: function() {
            return this.previousCollectionsField;
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function() {
        var field = this.getOption('field');
        var sourceFields = field.sourceFields;
        var catalog = this.model.collection.catalog;

        if (sourceFields && sourceFields.previousCollections) {
            this.previousCollectionsField = catalog.getFieldDefinition(sourceFields.previousCollections);
        }
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        var modelDate = this.model.getHistoryValue(0, 'date');

        this.renderSelectOptions(
            this.ui.selectPurchasingCurrency,
            App.radio().request('currencies:collection'),
            'key',
            'shortName',
            function(option) {
                if (this.model.getHistoryValue(0, 'currency') != '') {
                    return this.model.getHistoryValue(0, 'currency') == option.value;
                } else {
                    return this.options && this.options.objectHistoryCurrency === option.value
                }
            }.bind(this)
        );

        // Render year select
        this.renderSelectOptions(
            this.ui.selectDateYear,
            _.range(new Date().getFullYear(), new Date().getFullYear() - 200, -1),
            null,
            null,
            function(option) {
                var year = App.util.getYear(modelDate);

                return year && (year === option.value);
            }.bind(this),
            null,
            {name: App.t('collection::edit:object-history:date:year:placeholder'), disable: false}
        );

        // Render month select
        var months = [];
        _.each(_.range(1, 13), function(item) {
            months.push({key: item, name: App.t('global::month', item)});
        })

        this.renderSelectOptions(
            this.ui.selectDateMonth,
            months,
            'key',
            'name',
            function(option) {
                var month = App.util.getMonth(modelDate);

                return month && (month === option.value);
            }.bind(this),
            null,
            {name: App.t('collection::edit:object-history:date:month:placeholder'), disable: false}
        );

        // Render day select
        this.renderSelectOptions(
            this.ui.selectDateDay,
            _.range(1, 32),
            null,
            null,
            function(option) {
                var day = App.util.getDay(modelDate);

                return day && (day === option.value);
            }.bind(this),
            null,
            {name: App.t('collection::edit:object-history:date:day:placeholder'), disable: false}
        );
    },

    onShow: function() {
        this.reset();

        this.checkTypeValue();
    },

    onAttach: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    checkTypeValue: function() {
        this.$el.removeClass(function(index, css) {
            return (css.match(/(^|\s)history-state-\S+/g) || []).join(' ');
        });

        var type = this.ui.typeValue.filter(':checked').val();
        this.$el.addClass('history-state-' + (type ? type : 'none'));

        //disable price inputs for every type but purchased
        this.$('.history-addition-for').find('input select').prop('disable', type === 'purchased');
    },

    getData: function(defaults) {
        var data = {};
        var field = this.getOption('field');

        var history = [];

        var historyContainers = this.$el; //@todo switch to container element, if multiple history entries are supported
        historyContainers.each(function(index, container) {
            container = $(container);

            //type
            var type = container.find('[name="history[' + index + '].type"]:checked').val();

            //from
            var from = container.find('[name="history[' + index + '].from"]').val().trim();

            //price
            var price = container.find('[name="history[' + index + '].price"]').val();
            var currency = container.find('[name="history[' + index + '].currency"]').val();

            //date
            var year = container.find('[name="history[' + index + '].date.year"]').val().trim();
            var month = container.find('[name="history[' + index + '].date.month"]').val().trim();
            var day = container.find('[name="history[' + index + '].date.day"]').val().trim();
            var date = App.util.getIsoDate(year, month, day);

            if (type || from || price || date) {
                history.push({
                    type: type,
                    from: from,
                    price: price ? price.trim() : null,
                    currency: currency ? currency.trim() : null,
                    date: date,
                });
            }
        });

        data[field.name] = history;

        if (this.previousCollectionsField) {
            data[this.previousCollectionsField.name] = this.$('[name="' + this.previousCollectionsField.name + '"]').val().trim();
        }

        return data;
    },
});

module.exports = HistoryComponent;